import { $type } from '../utils/di-container.js';

/**
 * Service used to hold and yield feature toggles information
 */
export class FeatureService {

  /** @type {string[]} */
  features = [];

  /**
   * @param {string[]} features
   */
  setFeatures(features) {
    if (features) {
      this.features = features;
    }
  }

  enable(feature) {
    if (this.features.indexOf(feature) < 0) {
      this.features.push(feature);
    }
  }

  disable(feature) {
    this.features = this.features.filter(f => f !== feature);
  }

  /**
   * @param {string} feature
   * @returns {boolean}
   */
  isEnabled(feature) {
    return this.features.indexOf(feature) >= 0;
  }

}

FeatureService[$type] = Symbol('FeatureService');
